/**
 * Formata telefone completo
 * 82999999999 → "(82) 99999-9999"
 * 8233334444 → "(82) 3333-4444"
 */
export function formatPhone(phone: string): string {
  const digits = phone.replace(/\D/g, '')
  if (digits.length === 11) return digits.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3')
  if (digits.length === 10) return digits.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3')
  return phone
}

/**
 * Máscara de input: formata enquanto digita
 * "82999" → "(82) 999"
 * "82999999999" → "(82) 99999-9999"
 */
export function maskPhone(value: string): string {
  const digits = value.replace(/\D/g, '').slice(0, 11)
  if (digits.length <= 2) return digits.length ? `(${digits}` : ''
  if (digits.length <= 6) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`
  if (digits.length <= 10) return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`
  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`
}

/**
 * Remove máscara, retorna só dígitos
 * "(82) 99999-9999" → "82999999999"
 */
export function unmaskPhone(value: string): string {
  return value.replace(/\D/g, '')
}
